export default "__VITE_ASSET__9gcEGKuh__"